import { render, staticRenderFns } from "./tm-notification.vue?vue&type=template&id=d1f1f2d2&"
import script from "./tm-notification.vue?vue&type=script&lang=ts&"
export * from "./tm-notification.vue?vue&type=script&lang=ts&"
import style0 from "./tm-notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports